import { render, staticRenderFns } from "./image.vue?vue&type=template&id=26a78852&scoped=true"
import script from "./image.vue?vue&type=script&lang=ts"
export * from "./image.vue?vue&type=script&lang=ts"
import style0 from "./image.vue?vue&type=style&index=0&id=26a78852&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a78852",
  null
  
)

export default component.exports